import { render, staticRenderFns } from "./ArrowUpwardLong.vue?vue&type=template&id=04a73cb0"
import script from "./ArrowUpwardLong.vue?vue&type=script&lang=js"
export * from "./ArrowUpwardLong.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports